import React, { PropTypes } from 'react';

const ResponsiveTable = ({ children }) => (
    <div className="responsive-table-wrap">
        <table
            cellPadding="0"
            cellSpacing="0"
            className="schedule align-left"
            data-text-contract="Contract table"
            data-text-expand="Expand table"
            data-fix-cols="0"
            data-behavior="responsive_table"
        >
            {children}
        </table>
    </div>
);

ResponsiveTable.propTypes = {
    children: PropTypes.node
};

export default ResponsiveTable;



// WEBPACK FOOTER //
// ./app/webapp/common/schedule/ResponsiveTable.js